import React from 'react'
import Spinner from 'common/components/Spinner'

const LoadingIndicator = function(props) {
  return (
    props.isLoading ?
      <div className='row text-center'>
        <Spinner />
      </div>
    :
      <div>{props.children}</div>
  )
}

export default LoadingIndicator
